import PDFDocument from './PDFDocument';

export default PDFDocument;
